import { useState, useEffect } from 'react'
import { supabase } from '../lib/supabase'
import { useTenant } from '../contexts/TenantContext'

export const useDivisions = (tournamentId) => {
  const { activeTenant } = useTenant()
  const [divisions, setDivisions] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (tournamentId && activeTenant) {
      fetchDivisions()
    }
  }, [tournamentId, activeTenant])

  const fetchDivisions = async () => {
    try {
      const { data, error } = await supabase
        .from('divisions')
        .select('*')
        .eq('tournament_id', tournamentId)
        .order('name')

      if (error) throw error
      setDivisions(data || [])
    } catch (err) {
      console.error('Error fetching divisions:', err)
    } finally {
      setLoading(false)
    }
  }

  const createDivision = async (divisionData) => {
    const { data, error } = await supabase
      .from('divisions')
      .insert([{ 
        ...divisionData, 
        tournament_id: tournamentId,
        tenant_id: activeTenant.id 
      }])
      .select()
      .single()

    if (error) throw error
    setDivisions([...divisions, data])
    return data
  }

  const deleteDivision = async (divisionId) => {
    const { error } = await supabase
      .from('divisions')
      .delete()
      .eq('id', divisionId)

    if (error) throw error
    setDivisions(divisions.filter(d => d.id !== divisionId))
  }

  return { divisions, loading, createDivision, deleteDivision, refetch: fetchDivisions }
}
